import update from 'immutability-helper';

import * as types from './types';

export interface IState {
  startTime: number;
  endTime: number;
  granularity: string;
  startPoint: number;
  endPoint: number;
  detailHighlightTime: number;
}

const initState: IState = {
  startTime: 0,
  endTime: 0,
  granularity: 'm',
  startPoint: 0,
  endPoint: 100,
  detailHighlightTime: 0,
};

const switchMap: {
  [key in keyof typeof types]?: (
    state: IState,
    action: Partial<{ type: keyof typeof types }>,
  ) => IState;
} = {};

switchMap[types.INIT] = state => update(state, { $set: initState });

switchMap[types.UPDATE_ZOOM_LEVEL] = (state, action) =>
  update(state, {
    $merge: action.zoomLevelConfig,
  });

switchMap[types.APPLY_TIMELINE_CONFIG] = (state, action) =>
  update(state, { $merge: action.config });

switchMap[types.TIMELINE_DETAIL_HIGHLIGHT] = (state, action) =>
  update(state, { detailHighlightTime: { $set: action.detailHighlightTime } });

export default (state = initState, action) =>
  switchMap[action.type] ? switchMap[action.type](state, action) : state;
